export const getUniqueId = (): string => {
  // Start unique ID with a letter or else the method document.querySelector will throw an error.
  return 'u' + Math.random().toString(36).slice(2);
};
